import { render, staticRenderFns } from "./RegPayRemain.vue?vue&type=template&id=78503930&scoped=true&"
import script from "./RegPayRemain.vue?vue&type=script&lang=js&"
export * from "./RegPayRemain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78503930",
  null
  
)

export default component.exports